import React, { useEffect, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { Box, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AndroidLogo from '../../../images/android.png';
import '../../../style/common.scss';
import { companyShortName } from "../../../services/Functions";

const logos = {
  10: { src: require('../../../images/discologos/pitc11-removebg-preview.png'), name: "PITC" },
  11: { src: require('../../../images/discologos/lesco.jpg'), name: "LESCO" },
  12: { src: require('../../../images/discologos/gepco.jpg'), name: "GEPCO" },
  13: { src: require('../../../images/discologos/fesco.jpg'), name: "FESCO" },
  14: { src: require('../../../images/discologos/iesco logo.png'), name: "IESCO" },
  15: { src: require('../../../images/discologos/mepco1.jpg'), name: "MEPCO" },
  26: { src: require('../../../images/discologos/pesco1.jpg'), name: "PESCO" },
  27: { src: require('../../../images/discologos/hazeco_logo-removebg-preview.png'), name: "HAZECO" },
  37: { src: require('../../../images/discologos/hesco logo.png'), name: "HESCO" },
  38: { src: require('../../../images/discologos/sepco.jpg'), name: "SEPCO" },
  48: { src: require('../../../images/discologos/qesco.png'), name: "QESCO" },
  59: { src: require('../../../images/discologos/tesco.jpg'), name: "TESCO" },
  91: { src: require('../../../images/discologos/sundar-logo.png'), name: "SUNDAR" },
};

const MobileAppStats = () => {
  const [stats, setStats] = useState([]);
  const { token, code } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          discoCode: '10',
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          "https://api-powersmart.pitc.com.pk/appUser/getRegisteredAppUsers",
          requestOptions
        );

        const result = await response.json();

        if (result?.status === "200" && result?.data?.length > 0) {
          console.log(result.data, "mobile app stats");
          const enhancedData = result.data.map(item => ({
            ...item,
            logo: logos[item.discoCode]?.src || logos[10].src,
            companyName: logos[item.discoCode]?.name || companyShortName(item.discoCode.toString()),
          }));
          setStats(enhancedData);
          console.log(enhancedData, "mobile app statss");
        } else {
          setStats([]);
          console.error("No data found:", result);
        }
      } catch (error) {
        console.error("Error fetching stats:", error);
        setStats([]);
      }
    };

    fetchStats();
  }, []);

  const disco10 = stats.find(item => item.discoCode === "10");
  console.log(stats, disco10, "disco10");
  const otherDiscos = stats.filter(item => item.discoCode !== "10");

  const complaintCharts = disco10 ? {
    chart: { type: "pie", height: 260, width: 400 },
    title: { text: "" },
    tooltip: { pointFormat: "<b>{point.y}</b> ({point.percentage:.1f}%)" },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.y} ({point.percentage:.1f}%)",
        },
      },
    },
    credits: { enabled: false },
    series: [
      {
        name: "Registered Users",
        colorByPoint: true,
        data: [
          { name: "Android Users", y: disco10.androidUsers || 0, color: '#27ae60' },
          { name: "iOS Users", y: disco10.iosUsers || 0, color: '#34495e' },
        ],
      },
    ],
  } : null;

  const comparisonChart = {
    chart: { type: "column", height: 310, width: 700 },
    title: { text: "" },
    xAxis: {
      categories: otherDiscos.map(item => item.companyName),
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: { text: "Total Users" },
      labels: {
        formatter: function () {
          return (this.value / 1000000).toFixed(2) + "M";
        },
      },
    },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        return this.points
          .map(
            (point) =>
              `<b>${point.series.name}:</b> ${(point.y / 1000000).toFixed(2)}M<br/>`
          )
          .join("");
      },
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        groupPadding: 0.1,
        borderWidth: 0,
      },
    },
    credits: { enabled: false },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle",
      itemMarginTop: 5,
      itemMarginBottom: 5,
    },
    series: [
      {
        name: "Android Users",
        data: otherDiscos.map(item => item.androidUsers || 0),
        color: "#27ae60",
      },
      {
        name: "iOS Users",
        data: otherDiscos.map(item => item.iosUsers || 0),
        color: "#34495e",
      },
      {
        name: "Total Users",
        data: otherDiscos.map(item => item.totalUsers || 0),
        color: "#3498db",
      },
    ],
  };

  const cardStyle = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
    display: "flex",
    minHeight: '130px',
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  };

  return (
    <Box className="form-box" sx={{ backgroundColor: "#f4f7fb", py: 4 }}>
      <Grid container sx={{ mx: "auto", px: 2 }}>
        <Grid
          item
          xs={12}
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 4 }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <img
              src={logos[10].src}
              alt="PITC Logo"
              style={{ maxWidth: "50px" }}
            />
            <Typography variant="h4" sx={{ color: '#7a0101', fontWeight: 'bold' }}>
              Power Smart Mobile App
            </Typography>
          </Box>
        </Grid>

        {stats.length > 0 ? (
          <>
            <Grid container spacing={2}>
              {disco10 && (
                <Grid item xs={6} className="mb-6">
                  <div
                    style={{
                      backgroundColor: "#fff",
                      padding: "20px",
                      borderRadius: "14px",
                      boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                    className="hover:scale-[1.02]"
                  >
                    <Typography
                      variant="h6"
                      className="font-bold text-[#34495e]"
                      sx={{ textAlign: "center", mb: 2 }}
                    >
                      Total Users
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "stretch",
                        justifyContent: "space-between",
                        width: "100%",
                        gap: "180px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          gap: "20px",
                          paddingLeft: "50px",
                          paddingRight: "25px",
                          borderRight: "2px solid #ddd",
                          flex: 1,
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={AndroidLogo}
                            alt="Android Logo"
                            style={{ width: "20px", height: "20px" }}
                          />
                          <div style={{ flex: 1, textAlign: "right", marginLeft: "6px" }}>
                            <Typography className="font-bold text-[#2c3e50]">
                              {disco10.androidUsers.toLocaleString()}
                            </Typography>
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <AppleIcon style={{ color: "#000" }} />
                          <div style={{ flex: 1, textAlign: "right", marginLeft: "6px" }}>
                            <Typography className="font-bold text-[#2c3e50]">
                              {disco10.iosUsers.toLocaleString()}
                            </Typography>
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <PeopleAltIcon style={{ color: "#3498db" }} />
                          <div style={{ flex: 1, textAlign: "right", marginLeft: "6px" }}>
                            <Typography className="font-bold text-[#2c3e50]">
                              {disco10.totalUsers.toLocaleString()}
                            </Typography>
                          </div>
                        </div>
                      </div>
                      <div style={{ flex: 1 }}>
                        <HighchartsReact highcharts={Highcharts} options={complaintCharts} />
                      </div>
                    </div>
                  </div>
                </Grid>
              )}
              <Grid item xs={6} className="mb-6">
                <div style={cardStyle}>
                  <HighchartsReact highcharts={Highcharts} options={comparisonChart} />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: 2 }}>
              {otherDiscos.map((item, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <div style={cardStyle} className="hover:scale-[1.02]">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingRight: "30px",
                          borderRight: "2px solid #ccc",
                        }}
                      >
                        <img
                          src={item.logo}
                          alt={`${item.companyName} Logo`}
                          style={{ maxWidth: "80px", marginBottom: "10px" }}
                        />
                        <Typography
                          variant="h6"
                          className="font-bold text-[#34495e] mb-0"
                          sx={{ textAlign: "center" }}
                        >
                          {item.companyName}
                        </Typography>
                      </div>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "stretch",
                          justifyContent: "center",
                          gap: "10px",
                          paddingLeft: "30px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <img
                            src={AndroidLogo}
                            alt="Android Logo"
                            style={{ width: "20px", height: "20px" }}
                          />
                          <div style={{ flex: 1, textAlign: "right" }}>
                            <Typography className="font-bold text-[#2c3e50]">
                              {item.androidUsers.toLocaleString()}
                            </Typography>
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <AppleIcon style={{ color: "#000" }} />
                          <div style={{ flex: 1, textAlign: "right" }}>
                            <Typography className="font-bold text-[#2c3e50]">
                              {item.iosUsers.toLocaleString()}
                            </Typography>
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <PeopleAltIcon style={{ color: "#3498db" }} />
                          <div style={{ flex: 1, textAlign: "right" }}>
                            <Typography className="font-bold text-[#2c3e50]">
                              {item.totalUsers.toLocaleString()}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>
          </>
        ) : (
          <Grid item xs={12} style={{ backgroundColor: '#fef5c0' }}>
            <Typography sx={{ textAlign: 'center', padding: '10px', fontWeight: 'bold', color: 'red' }}>
              No Data Found.
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default MobileAppStats;